export default "__VITE_ASSET__d258832f__"